// services/accountServices.js
import { API_END_POINTS } from "../../API_END_POINTS";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const showProfileUrl = `${API_BASE_URL}${API_END_POINTS.getProfileDetails}`;
const editProfileUrl = `${API_BASE_URL}${API_END_POINTS.editProfileDetails}`;
const changePasswordUrl = `${API_BASE_URL}${API_END_POINTS.changePassword}`;

export const getProfileDetails = async () => {
  try {
    const response = await axios.get(showProfileUrl, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Something went wrong!";
  }
};

export const editProfile = async (userData) => {
  try {
    const response = await axios.patch(editProfileUrl, userData, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data;
  }
};

export const changePassword = async (passwordData) => {
  try {
    const response = await axios.post(changePasswordUrl, passwordData, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return response;
  } catch (error) {
    throw error.response?.data;
  }
};
